import { atom } from "jotai";

export const showSideMenuAtom = atom(false);
